import create from "zustand";
import instance from "../config/axios";

const useStore = create((set) => ({
  isModal: false,
  setIsModal: () => set((state) => ({ isModal: !state.isModal })),
  dataCompare: [
    {
      dataset: [],
      label: [],
    },
  ],
  execute: async (url, payload) => {
    const response = await instance.post(url, payload);
    set({ dataCompare: await response.data });
  },
}));

export default useStore;
